export interface ValidationMessage {
  [key: string]: ValidationMessageType[];
}

export interface ValidationMessageType {
  type: string;
  message: string;
}
